import axios from 'axios';

import { apiPath } from '../../config/apiBase';

export const HELP_API = apiPath('/api/help');

function authHeaders() {
  const token = localStorage.getItem('token');
  return {
    withCredentials: true,
    headers: { Authorization: `Bearer ${token}` },
  };
}

export async function listHelpTopics() {
  const res = await axios.get(`${HELP_API}/topics`, authHeaders());
  return res.data;
}

export async function askHelp(question) {
  const res = await axios.post(`${HELP_API}/ask`, { question }, authHeaders());
  return res.data;
}

export async function openHelpTopic(entryId, question = '') {
  const res = await axios.post(`${HELP_API}/ask`, { entry_id: entryId, question }, authHeaders());
  return res.data;
}

export async function sendHelpFeedback(payload) {
  const res = await axios.post(`${HELP_API}/feedback`, payload, authHeaders());
  return res.data;
}

export async function createHelpArticle(payload) {
  const res = await axios.post(`${HELP_API}/articles`, payload, authHeaders());
  return res.data;
}

export async function updateHelpArticle(helpId, payload) {
  const res = await axios.put(`${HELP_API}/articles/${helpId}`, payload, authHeaders());
  return res.data;
}

export async function deleteHelpArticle(helpId) {
  const res = await axios.delete(`${HELP_API}/articles/${helpId}`, authHeaders());
  return res.data;
}

export async function listUnanswered() {
  const res = await axios.get(`${HELP_API}/unanswered`, authHeaders());
  return res.data;
}

export async function closeUnanswered(id) {
  const res = await axios.post(`${HELP_API}/unanswered/${id}/close`, {}, authHeaders());
  return res.data;
}

export async function scanTicketSuggestions() {
  const res = await axios.post(`${HELP_API}/ticket-suggestions/scan`, {}, authHeaders());
  return res.data;
}

export async function listTicketSuggestions() {
  const res = await axios.get(`${HELP_API}/ticket-suggestions`, authHeaders());
  return res.data;
}

export async function approveTicketSuggestion(id, payload) {
  const res = await axios.post(`${HELP_API}/ticket-suggestions/${id}/approve`, payload, authHeaders());
  return res.data;
}

export async function rejectTicketSuggestion(id) {
  const res = await axios.post(`${HELP_API}/ticket-suggestions/${id}/reject`, {}, authHeaders());
  return res.data;
}

export async function uploadHelpVideo(file, onProgress) {
  const form = new FormData();
  form.append('file', file);
  const res = await axios.post(`${HELP_API}/videos`, form, {
    ...authHeaders(),
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
    },
  });
  return res.data;
}

/** Uploaded videos need the auth header, so fetch as a blob and play via an object URL. */
export async function fetchHelpVideoBlob(filename) {
  const res = await axios.get(`${HELP_API}/videos/${filename}`, {
    ...authHeaders(),
    responseType: 'blob',
  });
  return res.data;
}

/** Turn a YouTube watch / short / embed link into an embeddable URL. */
export function youtubeEmbedUrl(url) {
  if (!url) return null;
  const m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
  return m ? `https://www.youtube.com/embed/${m[1]}` : null;
}

export const SOURCE_LABELS = {
  guide: 'Built-in guide',
  admin: 'Added by admin',
  ticket: 'From a resolved ticket',
  generated: 'From current settings',
  knowledge: 'Knowledge Base',
  live: 'Live data',
};
